import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFeaturedCoupons } from '../state/slices/couponSlice'

const PromotionalTwo = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const coupons = useSelector((state) => state.coupons.featuredCoupons)

    useEffect(() => {
        dispatch(fetchFeaturedCoupons())
    }, [dispatch])

    const handleCouponNavigateClick = (id) => {
        navigate(`/coupon/${id}`)
    }

    return (
        <section className="promotional-banner mt-40">
            <style>{`
                .promo-two-section-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                }
                .promo-two-title {
                    font-size: 20px;
                    font-weight: 700;
                    color: #0f172a;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin: 0;
                }
                .promo-two-accent {
                    display: inline-block;
                    width: 4px;
                    height: 20px;
                    background: linear-gradient(180deg, #4da8e8, #2575fc);
                    border-radius: 2px;
                    flex-shrink: 0;
                }
                .promo-two-view-all {
                    font-size: 13px;
                    font-weight: 600;
                    color: #2575fc;
                    padding: 6px 14px;
                    border: 1px solid #dde9ff;
                    border-radius: 99px;
                    background: #f0f5ff;
                    text-decoration: none;
                    transition: background 0.15s, color 0.15s;
                }
                .promo-two-view-all:hover {
                    background: #2575fc;
                    color: #fff;
                }
            `}</style>
            <div className="container container-lg">
                <div className="promo-two-section-header">
                    <h5 className="promo-two-title">
                        <span className="promo-two-accent" />
                        Featured Coupons
                    </h5>
                    <a href="/shop" className="promo-two-view-all">View All Coupons →</a>
                </div>
                <div className="row gy-4">
                    {
                        Array.isArray(coupons) && coupons.length > 0 ? (
                            coupons.map((coupon, key) => {
                                return (
                            <div key={key}className="col-lg-4 col-sm-6">
                                <div className="position-relative rounded-16 overflow-hidden z-1 p-32">
                                    <img
                                        src="assets/images/bg/promo-bg-img1.png"
                                        alt=""
                                        className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 object-fit-cover z-n1"
                                    />
                                    <div className="flex-between gap-16">
                                        <div className="w-75">
                                            <span className="text-heading text-sm mb-8">Featured Coupons</span>
                                            <h6 className="mb-0 text-truncate w-65">{coupon.title}</h6>
                                            <div
                                                onClick={()=> {handleCouponNavigateClick(coupon.id)}}
                                                className="d-inline-flex align-items-center gap-8 mt-16 text-heading text-md fw-medium border border-top-0 border-end-0 border-start-0 border-gray-900 hover-text-main-two-600 hover-border-main-two-600"
                                            >
                                                More Info
                                                <span className="icon text-md d-flex">
                                                    <i className="ph ph-plus" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="pe-xxl-4">
                                            <img
                                                src={coupon.image_url || "assets/images/thumbs/promo-img1.png"}
                                                alt={coupon.title}
                                                style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 12 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )
                                })
                            ) : (
                                <div>No coupons available</div>
                            )
                        }
                </div>
            </div>
        </section>


    )
}

export default PromotionalTwo
